import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  payPalButton: null,
  payPalCreditButton: null,
}

const payPalStylesSlice = createSlice({
  name: 'paypalStyles',
  initialState,
  reducers: {
    updatePayPalStyles: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
})

export const { updatePayPalStyles } = payPalStylesSlice.actions

export const payPalStylesSelector = state => state.paypalStyles

export default payPalStylesSlice.reducer
